<template>
  <div class="fast-step-list rounded-full overflow-hidden">
    <StepListItem v-for="step in steps" :key="step" :index="stepIndex(step)" :states="stepStates(step)" />
  </div>
</template>

<script>
import stepable from '../mixins/stepable'
import StepListItem from './StepListItem.vue'

export default {
  name: 'StepList',
  components: { StepListItem },
  mixins: [stepable],
  methods: {
    stepStates(step) {
      const states = []
      if (this.stepIndex(step) < this.maxStepIndex()) states.push('done')
      if (step === this.currentStep) states.push('current')
      if (!states.length) states.push('idle')
      return states
    }
  }
}
</script>

<style lang="scss">
.fast-step-list {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}
</style>
